import React, { useEffect, useMemo, useRef, useState, useCallback } from "react";
import AsyncCreatableSelect from "react-select/async-creatable";
import SearchableSelect from "util/component/SearchableSelect";
import DocList from "./docList";
import EquisDetail from "./equisDetail";
import CteateEquis from "./createEquis";
import {ClearableInput} from "../../../../util";
import axios from "../../../../util/axios";
import Preview from "./preview";
import {useSelector} from "react-redux";
import ModalPortal from "../../../../util/component/Modal";

import {Confirm, Modal} from "../../../../util/component/Modal/Modal";
import ModalPortal2 from "../../../../util/component/Modal2";
import { Modal2,Confirm2} from "../../../../util/component/Modal2/Modal";
import {useTranslation} from "react-i18next";


const EquisConfig = (props, _ref) => {

    const {SetEquisshow,equisData,RevInfo,project,equisType,equisDocList,HandleSuccessModal} = props

    const [ isShow, setIsShow ] = useState(false);
    const mainRef = useRef(null);

    const userSelector = useSelector(store => store.user);
    const { t } = useTranslation(["page"]);
    const [ equisDetailData, setEquisDetailData ] = useState({});
    const [ equisList, setEquisList ] = useState([]);
    const [ equisSearchList, setEquisSearchList ] = useState([]);
    const [ equisSearch , setEquisSearch] = useState({label:"Name",value:"name__v"})
    const [ SearchString, SetSearchString ] = useState("");
    const [equisPDF, setEquisPDF] = useState(false);
    const [ btnState,setBtnState] = useState({});
    const [ pcsGenerateState, setPcsGenerateState ] = useState("");
    const [equisERRModal, setEquisERRModal] = useState(false);
    const [equisERRMsgData, setEquisERRMsgData] = useState("");



    const [uploadConfrim, setUploadConfrim] = useState(false);
    const [createConfrim, setCreateConfrim] = useState(false);

    const [ createData , setCreateData] = useState({
        equisType:{label:"",value:""},
        equisSubType:{label:"",value:""},
        equisSubTypePick:{label:"",value:""},
        name:"",
        sharingRule:{label:"",value:""},
        customer:{label:"",value:""},
        process:{label:"",value:""},
        plant:{label:"",value:""},
        owningDepartment:{label:"",value:""},
        product:{label:"",value:""},
        lifecycle:"",

    });

    const HandleEquisERRModalOpen = () => {
        setEquisERRModal((OLD) => !OLD);
    };
    const HandleUploadConfrim = () => {
        setUploadConfrim((OLD) => !OLD);
    };
    const HandleCreateConfrim = () => {
        setCreateConfrim((OLD) => !OLD);
    };
    const HandleClose = (boolean) => {
        mainRef.current.classList.remove("show");
        mainRef.current.classList.add("hide");
        setTimeout(() => {
            SetEquisshow(false);
        }, 1000);
    };
    const HandleSuccessClose = (boolean) => {
        mainRef.current.classList.remove("show");
        mainRef.current.classList.add("hide");
        HandleSuccessModal(boolean)
        setTimeout(() => {
            SetEquisshow(false);
        }, 1000);
    };
    const HandleSetSearchString = (e) => {
        SetSearchString(e.target.value);
    }

    useEffect(() => {
        equisData?.docList? equisListDataSet(equisData.docList) :equisDetailDataSet(equisData);
    }, [equisData])


/*    useEffect(() => {
        let data =[{label : "All" , value:""}];
        equisList.forEach((rowData, index) => {
            data.push( {label:rowData.name__v + " (" +rowData.major_version_number__v +"."+rowData.minor_version_number__v+") ",value:rowData.id})
        });

        setEquisSearchList(data);


    }, [equisList])*/

    const equisDetailDataSet = (equisData) =>{
        setEquisDetailData(equisData)
        setBtnState({newBtn:false});
    }
    const equisListDataSet = (equisData) =>{
        setEquisList(equisData);
        setBtnState({newBtn:true});
    }

    const onSearch =(val) =>{
        setEquisSearch(val);
    }

    const onShow = () => {
        const { geneCode, revision, tempYn, selected } = RevInfo;
        const postData = {
            geneCode: geneCode,
            revision: selected ? selected.value : revision.maxRevision,
            tempYn: selected ? 'N' : tempYn,
            userId :  userSelector.userId,
            ...project
        }
        equisDocList(postData);
    }

    const PDFDownFunction = async (state) => {
        const { geneCode, revision, tempYn, selected } = RevInfo;
        let chkUri = "";
        let postData = {};
        if(state === "upload"){
            chkUri= '/veeva/uploadNewVersionCheck';
            postData = {
                geneCode: geneCode,
                revision: selected ? selected.value : revision.maxRevision,
                id: equisDetailData.id,
                userId:userSelector.userId

            }
        }else if(state === "create"){
            postData={};
            chkUri= '/veeva/createNewDocCheck';
        }
       const res =  await axios.post(process.env.REACT_APP_API + chkUri, postData);
       if(res.data.data.result !== "SUCCESS"){

            const value = {docNo:equisDetailData?.document_number__v}
            setEquisERRMsgData(t(res.data.data.result,{value}))
            HandleEquisERRModalOpen();
       }else{
            setPcsGenerateState(state)

            const uri = '/pcsGenerate/retrieveGenerateTemplateForSave';
            const { geneCode, revision, tempYn, selected } = RevInfo;
            const postData = {
                "geneCode": geneCode,
                revision: selected ? selected.value : revision.maxRevision,
                tempYn: selected ? 'N' : tempYn,
                ...project
            }
            const response = await axios.post(process.env.REACT_APP_API + uri, postData);
            const data = response.data.data;

            setEquisPDF({ ...data, revInfo: postData });
            //HandleSuccessClose(true);
       }
    }

    const equisFun = async () => {

        const { geneCode, revision, tempYn, selected } = RevInfo;

        let uri = "";
        let postData = {};
        if(pcsGenerateState === "upload"){
            uri= '/veeva/uploadNewVersion';
            postData = {
                geneCode: geneCode,
                revision: selected ? selected.value : revision.maxRevision,
                id: equisDetailData.id,
                userId:userSelector.userId

            }
        }else if(pcsGenerateState === "create"){
            uri= '/veeva/createNewDoc';
            postData = {
                "geneCode": geneCode,
                revision: selected ? selected.value : revision.maxRevision,
                tempYn: selected ? 'N' : tempYn,
                type__v :createData.equisType.label,
                subtype__v :createData.equisSubType.label,
                name__v :createData.name,
                sharing_rules__c :createData.sharingRule.label,
                process__c :createData.process.value,
                plant__c :createData.plant.value,
                owning_department__v :createData.owningDepartment.value,
                customer__c :createData.customer.value,
                product__v :createData.product.value,
                lifecycle__v :createData.lifecycle,
            }
        }
        await axios.post(process.env.REACT_APP_API + uri, postData)
                   .then((res) =>{
                       if(res.data.data.result !== "SUCCESS"){

                           const value = {docNo:equisDetailData?.document_number__v}
                           setEquisERRMsgData(t(res.data.data.result,{value}))
                           HandleEquisERRModalOpen();
                       }else{
                           HandleSuccessClose(true);
                       }
                   });

    }

    const PDFFunction = (data) => {
        setEquisPDF(false);
    }
    return (
        <div ref={mainRef} className={"equis-container show"}>
            <div className={"d-flex gap-10 closeBtn"}>
                <button className={"bpl-btn danger"} onClick={HandleClose}>
                   close
                </button>
            </div>

            <div className={"docWrap"}>
                {equisType === "equisY" &&
                <>
                {btnState.newBtn &&
                    <div className={"docLeft"}>
                        <h5 className={"section-title"}>Current PCS List in EQUIS</h5>
                        <div className={"docSearch"}>
                            <div>
                                <SearchableSelect
                                    border={"ON"}
                                    search={false}
                                    arrow
                                    placeholder=""
                                    name=""
                                    onChange={(val)=>onSearch(val)}
                                    value={equisSearch.value}
                                    options={[{label:"Name",value:"name__v"},{label:"Customer",value:"customer__c"},{label:"Product",value:"product__v"}]}
                                />
                            </div>
                            <div>
                                    <input type={'text'} style={{padding: "3px"}} onChange={HandleSetSearchString} value={SearchString || ""} />
                            </div>
                        </div>

                            <DocList
                                equisData = {equisList}
                                setEquisDetailData = {setEquisDetailData}
                                equisSearch = {equisSearch}
                                SearchString = {SearchString}
                            />

                    </div>
                }
                    <div className={"docRight"}>
                        <EquisDetail
                            onShow={onShow}
                            equisDetailData = {equisDetailData}
                            RevInfo = {RevInfo}
                            PDFDownFunction = {PDFDownFunction}
                            btnState = {btnState}
                            HandleUploadConfrim = {HandleUploadConfrim}
                            />
                    </div>
                </>
                }
                {equisType === "equisN" ?
                <div className={"createBox"}>
                        <CteateEquis revInfo = {RevInfo} PDFDownFunction = {PDFDownFunction}  createData = {createData} setCreateData = {setCreateData} HandleCreateConfrim = {HandleCreateConfrim} project = {project}/>

                </div>
                :""}
            </div>
            {equisPDF && (<div style={{ display: "none", position: "fixed", top: 0, left: 0, zIndex: 100, backgroundColor: "#FFF", width: "100%", height: "100%", overflow: "auto" }}>

                <Preview docData={equisPDF} func={PDFFunction} equisFun = {equisFun}/>
            </div>)}
            {equisERRModal && (
                <ModalPortal2>
                    <Modal2 onClose={HandleEquisERRModalOpen} danger>{equisERRMsgData}
                    </Modal2>
                </ModalPortal2>
            )}
            {uploadConfrim &&
                <ModalPortal2>
                    <Confirm2
                        onConfirm={() => PDFDownFunction("upload")}
                        onClose={() => HandleUploadConfrim()}>
                        <p className="text-center">진행 하시겠습니까?</p>
                        <br/>
                        <table className={"bpl-table-default text-center"}>
                            <colgroup>
                                <col width="130px"></col>
                            </colgroup>
                            <tbody>
                            <tr>
                                <th style={{borderTop: "1px solid #aaa"}}>DOC Id.</th>
                                <td style={{borderTop: "1px solid #aaa"}}>{equisDetailData?.id}</td>
                            </tr>
                            <tr>
                                <th>DOC No.</th>
                                <td>{equisDetailData?.document_number__v}</td>
                            </tr>
                            <tr>
                                <th>Name</th>
                                <td>{equisDetailData?.name__v}</td>
                            </tr>
                            </tbody>
                        </table>
                    </Confirm2>
                </ModalPortal2>
            }
            {createConfrim &&
                <ModalPortal2>
                    <Confirm2
                        onConfirm={() => PDFDownFunction("create")}
                        onClose={() => HandleCreateConfrim()}>
                        <p className="text-center">진행 하시겠습니까?</p>
                        <br/>
                        <table className={"bpl-table-default text-center"}>
                            <colgroup>
                                <col width="130px"></col>
                            </colgroup>
                            <tbody>
                            <tr>
                                <th style={{borderTop: "1px solid #aaa"}}>Type</th>
                                <td style={{borderTop: "1px solid #aaa"}}>{createData.equisType.label}</td>
                            </tr>
                            <tr>
                                <th>Sub Type.</th>
                                <td>{createData.equisSubType.label}</td>
                            </tr>
                            <tr>
                                <th>Name</th>
                                <td>{createData.name}</td>
                            </tr>
                            <tr>
                                <th>Sharing Rules</th>
                                <td>{createData.sharingRule.label}</td>
                            </tr>
                            <tr>
                                <th>Process</th>
                                <td>{createData.process.label}</td>
                            </tr>
                            <tr>
                                <th>Plant</th>
                                <td>{createData.plant.label}</td>
                            </tr>
                            <tr>
                                <th>Owning Department</th>
                                <td>{createData.owningDepartment.label}</td>
                            </tr>
                            <tr>
                                <th>Customer</th>
                                <td>{createData.customer.label}</td>
                            </tr>
                            <tr>
                                <th>Product</th>
                                <td>{createData.product.label}</td>
                            </tr>
                            <tr>
                                <th>LifeCycle</th>
                                <td>{createData.lifecycle}</td>
                            </tr>
                            </tbody>
                        </table>
                    </Confirm2>
                </ModalPortal2>
            }



        </div>

    );
};


export default React.memo(EquisConfig);

